import { get } from "lodash";

/**
 * Gets the current region code from the <meta name="current-region /> tag.
 * If there is no meta tag with such name, the promise is rejected.
 *
 * @return {Promise}
 */
export default function currentRegion() {
  return new Promise((resolve, reject) => {
    const currentRegionMetaTag = document.querySelector("meta[name='current-region']");
    const regionCode = get(currentRegionMetaTag, "content");

    if (regionCode === undefined) { reject("no-region"); }

    resolve(regionCode);
  });
}
